import React from 'react';
import ReactDOM from 'react-dom';
import Login from './components/Login';
import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import muiTheme from './components/ppappTheme'
import './rwdLimit.css'

try{
  injectTapEventPlugin()
}catch(err){
	console.log('使用injectTapEventPlugin出現錯誤(index.js), 錯誤資訊：', err)
}


ReactDOM.render(
	<MuiThemeProvider muiTheme={muiTheme}>
		<Login />
	</MuiThemeProvider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js